/**
 * @generated SignedSource<<4644280e954100d3547df16c7d73dd87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PinOption_node$data = {
  readonly __typename: string;
  readonly canPin?: {
    readonly value: boolean;
  };
  readonly canUnpin?: {
    readonly value: boolean;
  };
  readonly id: string;
  readonly pinned?: boolean;
  readonly " $fragmentType": "PinOption_node";
};
export type PinOption_node$key = {
  readonly " $data"?: PinOption_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"PinOption_node">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PinOption_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pinned",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canPin",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canUnpin",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "Announcement",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "9fb6bc30370ecc9571a5348e52ddbdc0";

export default node;
